// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgLanguage24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M21.75 12C21.75 6.76442 17.6233 2.49267 12.4444 2.25L12.288 2.25417L12 2.25L11.7125 2.25402C11.6605 2.25135 11.6081 2.25 11.5548 2.25998C6.37668 2.49267 2.25 6.76442 2.25 12C2.25 17.2356 6.37668 21.5073 11.5548 21.74L11.5556 21.75L11.713 21.7459L12 21.75L12.287 21.7459L12.4444 21.75L12.4452 21.74C17.6233 21.5073 21.75 17.2356 21.75 12ZM12 20.1838C10.9109 19.8603 9.90044 18.3735 9.30414 16.2511H14.6959L14.6158 16.5242C14.0118 18.4999 13.0423 19.8735 12 20.1838ZM19.0717 16.2513L16.2508 16.2505C15.9022 17.644 15.3834 18.8565 14.7336 19.7857C16.5579 19.1459 18.089 17.8825 19.0717 16.2513ZM4.92828 16.2513L7.74919 16.2505C8.09779 17.644 8.61664 18.8565 9.26634 19.7863C7.44209 19.1459 5.91099 17.8825 4.92828 16.2513ZM7.45112 9.25019L4.21934 9.25027C3.91539 10.1103 3.75 11.0359 3.75 12C3.75 12.9645 3.91552 13.8904 4.2197 14.7507L7.45127 14.7508C7.31966 13.8764 7.25 12.9528 7.25 12C7.25 11.0476 7.31961 10.1243 7.45112 9.25019ZM8.75 12C8.75 11.0326 8.82922 10.1078 8.97194 9.25038H15.0281C15.1708 10.1078 15.25 11.0326 15.25 12C15.25 12.9678 15.1707 13.8929 15.0279 14.7506H8.9721C8.82928 13.8929 8.75 12.9678 8.75 12ZM19.7807 9.25027L16.5489 9.25019C16.6804 10.1243 16.75 11.0476 16.75 12C16.75 12.9528 16.6803 13.8764 16.5487 14.7508L19.7803 14.7507C20.0845 13.8904 20.25 12.9645 20.25 12C20.25 11.0359 20.0846 10.1103 19.7807 9.25027ZM9.12131 4.26614L9.26635 4.21431C8.61648 5.14376 8.09755 6.35657 7.74895 7.75053L4.92768 7.74968C5.88422 6.16147 7.3606 4.92178 9.12131 4.26614ZM12 3.81615L11.9531 3.83084C10.8818 4.18269 9.89155 5.65754 9.30386 7.74989H14.6961C14.1258 5.71931 13.1764 4.27031 12.1416 3.86492L12 3.81615ZM14.8309 4.35699L14.7337 4.21369C16.5583 4.85426 18.0896 6.11805 19.0723 7.74968L16.2511 7.75053C15.92 6.42683 15.4354 5.26647 14.8309 4.35699Z"
				/>
			</Svg>
		);
	}
);
SvgLanguage24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgLanguage24;
